import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  Container,
  ContainerCardName,
  ContainerCardNameImage,
  ContainerRow,
  Image,
  Table,
  TableHeader,
  TableHeaderTitle,
  CardName,
} from './styles';

import CategoriesList from './categories-list';

const CardsComponent = (props) => {
  const {
    analyticsCardSort,
  } = props;

  const groupedAnalyticsByItemId = _.groupBy(analyticsCardSort, (item) => item.cardSortItem.id);

  return (
    <Container>
      <Table>
        <TableHeader>
          <TableHeaderTitle>Card</TableHeaderTitle>
          <TableHeaderTitle>Categories</TableHeaderTitle>
          <TableHeaderTitle>Frequency</TableHeaderTitle>
        </TableHeader>
        {_.map((groupedAnalyticsByItemId), (group) => (
          <ContainerRow key={group[0].cardSortItem.id}>
            <ContainerCardName>
              <ContainerCardNameImage>
                <CardName>{group[0].cardSortItem.name}</CardName>
                {group[0].cardSortItem.imageUrl && (
                  <Image
                    src={group[0].cardSortItem.imageUrl}
                    alt={group[0].cardSortItem.imageKey}
                  />
                )}
              </ContainerCardNameImage>
            </ContainerCardName>
            <CategoriesList group={group} />
          </ContainerRow>
        ))}
      </Table>
    </Container>
  );
};

CardsComponent.propTypes = {
  analyticsCardSort: PropTypes.arrayOf(PropTypes.shape({
    cardSortCategories: PropTypes.shape(),
    cardSortItems: PropTypes.shape(),
    frequencyPercentage: PropTypes.number,
    frequencyTotal: PropTypes.number,
  })).isRequired,
};

export default CardsComponent;
